import merge from 'lodash/merge';
import ReactApexChart from 'react-apexcharts';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { Box, Card, Typography, Stack, CardProps } from '@mui/material';
// utils

// components

import { useStore } from 'src/stores/store';
import { useEffect } from 'react';
import { BaseOptionChart } from 'src/components/chart';
import { fNumber } from 'src/utils/formatNumber';
import TrendingUpIcon from '@mui/icons-material/TrendingUp'; // Icon for trends
import BarChartIcon from '@mui/icons-material/BarChart'; // Icon for bar charts
import ShowChartIcon from '@mui/icons-material/ShowChart';
// ----------------------------------------------------------------------

const IconWrapperStyle = styled('div')(({ theme }) => ({
  width: 80,          // Increased width
  height: 80,         // Increased height
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(2),
  color: theme.palette.primary.main,
  backgroundColor: alpha(theme.palette.primary.main, 0.12),
}));

// ----------------------------------------------------------------------

interface Props extends CardProps {
  title: string;
  total?: number;
  percent: number;
  chartColor: string;
 
  icon?: React.ReactNode; // Add dynamic icon prop
}

export default function WidgetSummary({
  title,
  percent,
  total,
  chartColor,
  
  icon,
  sx,
  ...other
}: Props) {
  const chartOptions = merge(BaseOptionChart(), {
    colors: [chartColor],
    chart: { animations: { enabled: true }, sparkline: { enabled: true } },
    stroke: { width: 2 },
    tooltip: {
      x: { show: false },
      y: {
        formatter: (seriesName: string) => fNumber(seriesName),
        title: {
          formatter: () => '',
        },
      },
      marker: { show: false },
    },
  });

  return (
    <Card sx={{ display: 'flex', alignItems: 'center', p: 3, ...sx }} {...other}>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2" paragraph>
          {title}
        </Typography>
        <Typography variant="h3" gutterBottom>
          {fNumber(total!)}
        </Typography>
      </Box>
      {icon && <IconWrapperStyle>{icon}</IconWrapperStyle>}
      {/* <ReactApexChart
        type="line"
        series={[{ data: chartData }]}
        options={chartOptions}
        width={120}
        height={80}
      /> */}
    </Card>
  );
}
